import { render } from "./OrderBill.vue?vue&type=template&id=323bfb54"
import script from "./OrderBill.vue?vue&type=script&lang=js"
export * from "./OrderBill.vue?vue&type=script&lang=js"

import "./OrderBill.vue?vue&type=style&index=0&id=323bfb54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__